import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import logo from "../../assets/images/logo/app-logo.svg";
import Button from "../../components/global/button/Button";
import {
  AddBillCode,
  updateBillCode,
} from "../../services/api_services/PaymentService";

export default function AddEditBillCodeModal(props) {
  const [isBillCodeAPILoading, setIsBillCodeAPILoading] = useState(false);
  const consultant = JSON.parse(sessionStorage.getItem("ConsultantDetails"));
  const isConsultantUser = consultant !== null;
  const client = JSON.parse(sessionStorage.getItem("ClientDetails"));
  const isClientUser = client !== null;
  const [organizationId] = useState(
    !isConsultantUser
      ? !isClientUser
        ? JSON.parse(sessionStorage.getItem("OrgDetails2")).id
        : JSON.parse(sessionStorage.getItem("ClientDetails"))
          .organizationsSet[0]?.id
      : JSON.parse(sessionStorage.getItem("ConsultantDetails")).organizationId
  );


  const organizationFlagDetails = JSON.parse(sessionStorage.getItem("OrgDetails2"));
  const [isBillWithGst, setIsBillWithGst] = useState(organizationFlagDetails?.billWithGst
    ? true : false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Please enter bill code name"),
    descr: Yup.string().required("Please enter description"),
    taxRate: Yup.number("Invalid tax rate.").min(
      0,
      "Tax rate can be minimum 0 %."
    ),
    rate: Yup.number("Invalid rate.")
      .min(0, "Rate can be minimum 0.")
      .required("Rate is required."),
  });

  useEffect(() => {
    const handleOrgUpdate = () => {
      const updatedOrg = JSON.parse(sessionStorage.getItem("OrgDetails2"));
      setIsBillWithGst(updatedOrg?.billWithGst ? true : false);
    };

    window.addEventListener("orgDetailsUpdated", handleOrgUpdate);

    return () => {
      window.removeEventListener("orgDetailsUpdated", handleOrgUpdate);
    };
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (values) => {
    setIsBillCodeAPILoading(true);
    let response;
    if (!props?.isEditModal || props?.isModalFromGenerateInvoice) {
      response = await AddBillCode({
        ...values,
        name: values.name.trim(),
        organizationId: organizationId,
        hsrCode: "",
        hsn_sac_code: values.hsn_sac_code,
        cgst: values.cgst,
        sgst: values.sgst,
      });
    } else {
      response = await updateBillCode({
        ...values,
        name: values.name.trim(),
        organizationId: props?.billCode.organizationId,
        hsrCode: props?.billCode.hsrCode,
        id: props?.billCode.id,
        hsn_sac_code: values.hsn_sac_code,
        cgst: values.cgst,
        sgst: values.sgst,
      });
    }

    setIsBillCodeAPILoading(false);
    if (response) {
      props.getBillCodeList(response, props?.indexOfNewBillItem);
      props.onHide();
    }
  };
  return (
    <Modal
      size="md"
      centered
      show={props.show}
      onHide={props.onHide}
      dialogClassName="Appointment-modal"
    >
      <Formik
        initialValues={{
          name:
            props.isEditModal || props?.isModalFromGenerateInvoice
              ? props?.billCode.name
              : "",
          descr:
            props.isEditModal || props?.isModalFromGenerateInvoice
              ? props?.billCode.descr
              : "",
          hsn_sac_code:
            props.isEditModal || props?.isModalFromGenerateInvoice
              ? props?.billCode.hsn_sac_code
              : "",
          taxRate:
            props.isEditModal || props?.isModalFromGenerateInvoice
              ? props?.billCode.taxRate
              : "",
          rate:
            props.isEditModal || props?.isModalFromGenerateInvoice
              ? props?.billCode.rate
              : "",

          cgst:
            props.isEditModal || props?.isModalFromGenerateInvoice
              ? props?.billCode.cgst
              : "",
          sgst:
            props.isEditModal || props?.isModalFromGenerateInvoice
              ? props?.billCode.sgst
              : "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            <ModalBody>
              <div className="text-center">
                <img src={logo} alt="" height="30" />
                <h6 className="text-center" style={{ marginTop: "10px" }}>
                  Add Bill code
                </h6>
                <h6 className="text-center text-muted">
                  Include information regarding bill code.
                </h6>
              </div>
              <div className="mt-3">
                <h6 className="txt-error text-center">
                  *Please ensure that all fields are completed.
                </h6>

                <div className="form-floating mb-3">
                  <Field
                    className={`form-control ${errors.name && touched.name && "is-invalid"
                      }`}
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Bill code name"
                    onChange={(e) => {
                      const { name, value } = e.target;
                      setFieldValue(name, value.replace(/\s+/g, " "));
                    }}
                    required
                  />
                  <label htmlFor="name">
                    <span>Bill code Name</span>
                  </label>
                  <div
                    className={`${errors.name && touched.name
                        ? "invalid-feedback"
                        : "valid-feedback"
                      }`}
                  >
                    {errors.name}
                  </div>
                </div>

                {
                  isBillWithGst && (
                    <div className="form-floating mb-3">
                      <Field
                        className={`form-control ${errors.descr && touched.descr && "is-invalid"
                          }`}
                        type="text"
                        id="hsn_sac_code"
                        name="hsn_sac_code"
                        placeholder="HSN/HSC Code"

                      />
                      <label htmlFor="descr">
                        <span>HSN/HSC Code</span>
                      </label>
                      <div
                        className={`${errors.descr && touched.descr
                            ? "invalid-feedback"
                            : "valid-feedback"
                          }`}
                      >
                        {errors.descr}
                      </div>
                    </div>
                  )
                }

                <div className="form-floating mb-3">
                  <Field
                    className={`form-control ${errors.descr && touched.descr && "is-invalid"
                      }`}
                    type="text"
                    id="descr"
                    name="descr"
                    placeholder="Description"
                    required
                  />
                  <label htmlFor="descr">
                    <span>Description</span>
                  </label>
                  <div
                    className={`${errors.descr && touched.descr
                        ? "invalid-feedback"
                        : "valid-feedback"
                      }`}
                  >
                    {errors.descr}
                  </div>
                </div>
                <div className="form-floating mb-3">
                  <Field
                    className={`form-control ${errors.rate && touched.rate && "is-invalid"
                      }`}
                    type="number"
                    id="rate"
                    name="rate"
                    placeholder="Rate"
                    required
                  />
                  <label htmlFor="rate">
                    <span>Rate</span>
                  </label>
                  <div
                    className={`${errors.rate && touched.rate
                        ? "invalid-feedback"
                        : "valid-feedback"
                      }`}
                  >
                    {errors.rate}
                  </div>
                </div>

                {
                  isBillWithGst && (
                    <>
                      <div className="form-floating mb-3">
                        <Field
                          className={`form-control ${errors.cgst && touched.cgst && "is-invalid"
                            }`}
                          type="number"
                          id="cgst"
                          name="cgst"
                          placeholder="CGST"
                        />
                        <label htmlFor="cgst">
                          <span>CGST</span>
                        </label>
                        <div
                          className={`${errors.cgst && touched.cgst
                              ? "invalid-feedback"
                              : "valid-feedback"
                            }`}
                        >
                          {errors.taxRate}
                        </div>
                      </div>
                      <div className="form-floating mb-3">
                        <Field
                          className={`form-control ${errors.sgst && touched.sgst && "is-invalid"
                            }`}
                          type="number"
                          id="sgst"
                          name="sgst"
                          placeholder="SGST"
                        />
                        <label htmlFor="sgst">
                          <span>SGST</span>
                        </label>
                        <div
                          className={`${errors.taxRate && touched.taxRate
                              ? "invalid-feedback"
                              : "valid-feedback"
                            }`}
                        >
                          {errors.taxRate}
                        </div>
                      </div>
                    </>
                  )
                }


              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                isLoading={isBillCodeAPILoading}
                disabled={isBillCodeAPILoading}
                buttonTitle={
                  isBillCodeAPILoading
                    ? "Loading..."
                    : `${props.isEditModal ? "Update bill code" : "Add bill Code"
                    }`
                }
              />
              <Button
                className="secondary outline"
                type="reset"
                onClick={() => props.onHide()}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
